import { getCookie, setCookie } from "src/utils/cookies";

type CookieStatusValue = "closed" | "submitted";

export const setStatusToCookie = (
  status: CookieStatusValue,
  maxAge: number,
  cookieName?: string
) => {
  setCookie(cookieName ?? "subscribe_to_newsletter_popup", status, {
    maxAge
  });
};

export const getStatusFromCookie = (
  cookieName?: string
): CookieStatusValue | undefined => {
  return getCookie(
    cookieName ?? "subscribe_to_newsletter_popup"
  ) as CookieStatusValue;
};
